// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog[data-v-34c3bbea]  .modal-body{width:420px}.title[data-v-34c3bbea]{word-wrap:break-word;font-size:1.28571rem;line-height:1.57143rem;color:#000;margin:0 auto 30px;text-align:center}.btns-wrapper[data-v-34c3bbea]{width:100%;display:flex;flex-direction:row;align-items:center;justify-content:space-between}.btns-wrapper .btn[data-v-34c3bbea]{width:144px}", ""]);
// Exports
module.exports = exports;
